var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupBase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0C8.512 0 0 8.512 0 19C0 29.488 8.512 38 19 38C29.488 38 38 29.488 38 19C38 8.512 29.488 0 19 0ZM25.859 12.046C27.892 12.046 29.526 13.68 29.526 15.713C29.526 17.746 27.892 19.38 25.859 19.38C23.826 19.38 22.192 17.746 22.192 15.713C22.173 13.68 23.826 12.046 25.859 12.046ZM14.459 9.044C16.929 9.044 18.943 11.058 18.943 13.528C18.943 15.998 16.929 18.012 14.459 18.012C11.989 18.012 9.975 15.998 9.975 13.528C9.975 11.039 11.97 9.044 14.459 9.044ZM14.459 26.391V33.516C9.899 32.091 6.289 28.576 4.693 24.092C6.688 21.964 11.666 20.881 14.459 20.881C15.466 20.881 16.739 21.033 18.069 21.299C14.953 22.952 14.459 25.137 14.459 26.391ZM19 34.2C18.487 34.2 17.993 34.181 17.499 34.124V26.391C17.499 23.693 23.085 22.344 25.859 22.344C27.892 22.344 31.407 23.085 33.155 24.529C30.932 30.172 25.441 34.2 19 34.2Z",
    fill: "url(#paint0_linear_5331_20281)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5331_20281",
    x1: 19,
    y1: 0,
    x2: 19,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#255986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupBase);
export default __webpack_public_path__ + "static/media/group_base.1668f244130bf87f9b15481deb15795d.svg";
export { ForwardRef as ReactComponent };